// Shown in place of a missing value on detail screens (e.g. an order's
// job number), so the label stays
// and the engineer can see the value is genuinely empty.
export const EMPTY_VALUE = '—'

// The in-stock label and search filter. Stock may be on the branch shelf or
// in the supplier's warehouse (DC), so the wording names both.
export const IN_STOCK_LABEL = 'Available Warehouse or Branch'
